export const errorMessages = {
  "errors.unexpected_error": "Something went wrong. Please try again.",
  "errors.request_failed": "The request could not be completed.",
  "errors.network": "The server could not be reached. Please try again.",
  "errors.validation_error": "The request contains invalid fields.",
  "errors.concurrent_update":
    "This item changed elsewhere. Your edits are still here; refresh, review, and try again.",
  "errors.entry_not_found": "Book not found.",
  "errors.entry_archived": "Archived books cannot receive session corrections.",
  "errors.wishlist_entry":
    "Move this book out of the wishlist before recording progress.",
  "errors.invalid_time_range": "Check the session start, end, and active duration.",
  "errors.invalid_timezone": "Enter a valid IANA timezone.",
  "errors.page_beyond_end": "The corrected sessions exceed the book's page count.",
  "errors.book_required": "A progress session must remain associated with a book.",
  "errors.progress_inconsistent": "Stored progress cannot be corrected safely.",
  "errors.invalid_credentials": "Incorrect username or password",
  "errors.session_invalid": "Session has expired",
  "errors.refresh_invalid": "Session has expired",
  "errors.refresh_missing": "Session has expired",
  "errors.login_throttled": "Too many sign-in attempts. Try again later.",
  "errors.account_inactive": "Account is inactive",
  "errors.email_unverified": "Verify your email address before signing in",
  "errors.origin_forbidden": "Origin is not allowed",
  "errors.book_not_found": "Book not found",
  "errors.archived_book_not_found": "Archived book not found",
  "errors.catalog_edition_not_found": "Catalog edition not found",
  "errors.reading_session_not_found": "Reading session not found",
  "errors.journal_entry_not_found": "Journal entry not found",
  "errors.reading_goal_not_found": "Reading goal not found",
  "errors.collection_not_found": "Collection not found",
  "errors.tag_not_found": "Tag not found",
  "errors.import_job_not_found": "Import job not found",
  "errors.profile_not_found": "Profile not found",
  "errors.review_not_found": "Review not found",
  "errors.club_not_found": "Book club not found",
  "errors.external_provider_unavailable": "The external book provider is unavailable.",
  "errors.external_search_rate_limited": "Book search is temporarily rate limited.",
  "errors.book_isbn_not_found": "No book was found with ISBN {isbn}.",
  "errors.book_provider_id_not_found":
    "No book was found with provider ID {provider_id}.",
} as const;
